import React from 'react';
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import CustomModal from 'src/components/configuracion/components/customModal';
import CommentMentionText from 'src/components/general/CommentMentionText';
import 'src/components/documentostributarios/ModalDeleteObligations.scss';

function DeleteCommentModalContent({ note }) {
  if (!note) {
    return (
      <div className="delete-obligation-modal-body">
        <p className="delete-obligation-modal-lead">Cargando…</p>
      </div>
    );
  }

  const author = note.user?.email || note.user?.name || 'Usuario';
  const dateLabel = note.date ? moment(note.date).format('LLL') : '—';

  return (
    <div className="delete-obligation-modal-body">
      <div className="delete-obligation-modal-icon" aria-hidden>
        <FeatherIcon icon="trash-2" size={22} />
      </div>

      <p className="delete-obligation-modal-lead">
        ¿Eliminar <strong>este comentario</strong>? La acción no se puede deshacer.
      </p>

      <div className="delete-obligation-modal-summary">
        <div className="delete-obligation-modal-summary-type">Comentario</div>
        <div className="delete-obligation-modal-summary-row">
          <span className="delete-obligation-modal-summary-label">Autor</span>
          <span className="delete-obligation-modal-summary-value">{author}</span>
        </div>
        <div className="delete-obligation-modal-summary-row">
          <span className="delete-obligation-modal-summary-label">Fecha</span>
          <span className="delete-obligation-modal-summary-value">{dateLabel}</span>
        </div>
        <div className="delete-obligation-modal-summary-row delete-obligation-modal-summary-row--stacked">
          <span className="delete-obligation-modal-summary-label">Mensaje</span>
          <div className="delete-obligation-modal-summary-comment">
            <CommentMentionText text={note.comment} mentionClassName="mention" />
          </div>
        </div>
      </div>

      <p className="delete-obligation-modal-warning">
        El comentario se quitará de forma permanente para todos los usuarios con acceso.
      </p>
    </div>
  );
}

const DeleteCommentModal = ({
  open,
  onClose,
  onConfirm,
  note,
  isLoading = false,
}) => {
  const handleCancel = () => {
    if (!isLoading) onClose?.();
  };

  return (
    <CustomModal
      open={open}
      onClose={handleCancel}
      size="small"
      dimmer="blurring"
      closeOnDimmerClick={!isLoading}
      closeOnEscape={!isLoading}
      classNameModal="delete-obligation-modal delete-comment-modal"
      classNameContent="delete-obligation-modal-content"
      title="Eliminar comentario"
      content={<DeleteCommentModalContent note={note} />}
      cancelarLabel="Cancelar"
      confirmLabel="Eliminar"
      onConfirm={onConfirm}
      confirmVariant="danger"
      isLoading={isLoading}
    />
  );
};

export default DeleteCommentModal;
